import axios, {AxiosRequestConfig} from 'axios'
import qs from 'qs'
import {Errors} from '@/utils/Errors'

export default class HttpClient
{
    endPoint: string
    authToken: string | null = null
    onUnauthorizedCallback?: () => void

    constructor(endPoint: string) {
        this.endPoint = endPoint
    }

    setAuthToken(token: string | null) {
        this.authToken = token
    }

    onUnauthorized() {
        if (this.onUnauthorizedCallback instanceof Function) {
            this.onUnauthorizedCallback()
        }
    }

    addAuth(config: AxiosRequestConfig) {
        if (!config.headers) {
            config.headers = {}
        }
        if (!config.headers.Authorization) {
            config.headers.Authorization = 'Bearer ' + this.authToken
        }
        return config
    }

    makeUrl(path: string, query = {}) {
        return this.endPoint + '/' + path + (query ? '?' + qs.stringify(query) : '')
    }

    async get<ResponseType>(url: string, query: object = {}, params: object = {}): Promise<ResponseType> {
        try {
            const response = await axios.get<ResponseType>(
                this.makeUrl(url, query),
                this.addAuth({params}),
            )
            return response.data
        } catch (error) {
            const errorObject = error as { response: { status: number, data?: object } }
            if (errorObject.response.status === 401) {
                this.onUnauthorized()
            }
            throw parse(errorObject.response?.data)
        }
    }

    async post<ResponseType>(url: string, data: object, signal: AbortSignal|undefined = undefined): Promise<ResponseType> {
        data = data || {}

        try {
            const response = await axios.post<ResponseType>(
                this.makeUrl(url),
                data,
                this.addAuth({signal}),
            )
            return response.data
        } catch (error) {
            const errorObject = error as { response: { status: number, data?: object } }
            if (errorObject.response.status === 401) {
                this.onUnauthorized()
            }
            throw parse(errorObject.response?.data)
        }
    }
}

// eslint-disable-next-line
function parse(data: any) {
    if (data != null) {
        if (data.type && data.message) {
            return new BackendException(data as object)
        } else {
            return new ValidationErrors(data as object)
        }
    }
}

export class BackendException
{
    message!: string

    constructor(exceptionData: object) {
        Object.assign(this as unknown as ObjectConstructor, exceptionData)
        if (this.message == null) {
            this.message = 'Произошла неопознанная ошибка на стороне сервера'
        }
    }
}

export class ValidationErrors implements Errors
{
    [key: string]: string[]

    constructor(errorsData: object) {
        Object.assign(this as unknown as ObjectConstructor, errorsData)
    }
}

